// Get main dom element
const recipeContainer: HTMLElement | null = document.querySelector(
  "#recipe-search-data"
);

// Mock implementation, real implementation will not have OR operators
const translations = {
  readMoreButton: recipeContainer?.getAttribute("data-read-more-button") || "",
  loadMoreButton: recipeContainer?.getAttribute("data-load-more-button") || "",
  searchCopy: recipeContainer?.getAttribute("data-search-copy") || "",
  filterCopy: recipeContainer?.getAttribute("data-filter-copy") || "",
  resetCopy: recipeContainer?.getAttribute("data-reset-copy") || "",
  showMoreButton: recipeContainer?.getAttribute("data-show-more-button") || "",
  submitButton: recipeContainer?.getAttribute("data-submit-button") || "",
  headlineRecipeSteps: recipeContainer?.getAttribute(
    "data-headline-recipe-steps" || ""
  ),
  headlineIngredients: recipeContainer?.getAttribute(
    "data-headline-ingredients" || ""
  ),
  knowHow: recipeContainer?.getAttribute("data-know-how") || "",
  recipeTools: recipeContainer?.getAttribute("data-recipe-tools") || "",
  recipeStep: recipeContainer?.getAttribute("data-recipe-step-label") || "",
  searchMoreCopy: recipeContainer?.getAttribute("data-search-more-copy") || "",
  goToRecipeCopy: recipeContainer?.getAttribute("data-go-to-recipe-copy") || "",
  searchInputPlaceholder: recipeContainer?.getAttribute(
    "data-search-input-copy" || ""
  ),
  findOtherRecipeCopy: recipeContainer?.getAttribute(
    "data-find-other-recipe-copy" || ""
  ),
  findOtherRecipeButton: recipeContainer?.getAttribute(
    "data-find-other-recipe-button" || ""
  ),
  relatedRecipesHeaderCopy: recipeContainer?.getAttribute(
    "data-related-recipes-header-copy" || ""
  ),
  resultsCopy: recipeContainer?.getAttribute("data-results-copy" || ""),
  filteredbyCopy: recipeContainer?.getAttribute("data-filterby-copy" || ""),
  printButtonLabel: recipeContainer?.getAttribute(
    "data-print-button-label" || ""
  ),
  recommendButtonLabel: recipeContainer?.getAttribute(
    "data-recommend-button-label" || ""
  ),
  recipesCopy: recipeContainer?.getAttribute("data-recipes-copy" || ""),
  shareModalHeader: recipeContainer?.getAttribute(
    "data-share-modal-header" || ""
  ),
  openFilters: recipeContainer?.getAttribute("data-open-filters" || ""),
  noResultsFound: recipeContainer?.getAttribute("data-no-results" || ""),
};

export default translations;
